(function () {
  'use strict';

  var DATA = [];
  var selectedA = null;
  var selectedB = null;
  var dataLoaded = false;

  var modal, backdrop, inner, closeBtn, spinner;

  function init() {
    modal    = document.getElementById('bt-sg-modal');
    backdrop = document.getElementById('bt-sg-backdrop');
    inner    = document.getElementById('bt-sg-inner');
    closeBtn = document.getElementById('bt-sg-close');
    spinner  = document.getElementById('bt-sg-spinner');

    if (!modal) return;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-spec-guide-trigger]');
      if (!btn) return;
      var style = btn.getAttribute('data-style') || '';
      openGuide(style);
    });

    closeBtn.addEventListener('click', closeGuide);
    backdrop.addEventListener('click', closeGuide);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeGuide();
    });

    setupPanel('a');
    setupPanel('b');

    document.getElementById('bt-sg-change-a').addEventListener('click', function () { clearPanel('a'); });
    document.getElementById('bt-sg-change-b').addEventListener('click', function () { clearPanel('b'); });
  }

  function styleCandidatesFromPage() {
    var path = window.location.pathname;
    var match = path.match(/\/products\/([^/?]+)/);
    var handle = match ? match[1] : path.split('?')[0];
    var parts = handle.split('-');
    var cands = [];
    for (var i = parts.length - 1; i >= 0; i--) {
      var seg = parts[i];
      if (!/\d/.test(seg)) continue;
      if (!/^[a-z]{0,4}\d{2,6}[a-z]{0,4}$/i.test(seg)) continue;
      if (i > 0 && /[a-z]?\d/i.test(parts[i-1]) && /^\d+$/.test(seg)) {
        cands.push((parts[i-1] + '-' + seg).toUpperCase());
      }
      cands.push(seg.toUpperCase());
    }
    cands = cands.filter(function (v, idx, a) { return a.indexOf(v) === idx; });
    // Fallback for store-specific single-trailing-letter relabels (e.g. 3001C -> 3001,
    // BC3001C -> BC3001). Appended AFTER all exact candidates so an exact match always
    // wins first; the base is only tried when the suffixed form isn't in the data.
    var fallbacks = [];
    cands.forEach(function (c) {
      if (/\d[A-Z]$/.test(c)) {
        var base = c.slice(0, -1);
        if (cands.indexOf(base) === -1 && fallbacks.indexOf(base) === -1) fallbacks.push(base);
      }
    });
    // single-leading-letter strip (e.g. N1533 -> 1533): some brands carried in both
    // pipelines store the bare number while the page handle uses a 1-letter prefix.
    // Appended as a fallback; preloadFirst gates these on a brand-handle match so a
    // coincidental cross-brand number (G5200 vs Bayside 5200) can never mismap.
    cands.forEach(function (c) {
      var m = c.match(/^[A-Z](\d.*)$/);
      if (m) { var b = m[1]; if (cands.indexOf(b) === -1 && fallbacks.indexOf(b) === -1) fallbacks.push(b); }
    });
    return cands.concat(fallbacks);
  }

  function detectStyleFromPage() {
    var c = styleCandidatesFromPage();
    return c.length ? c[0] : '';
  }

  function openGuide(preloadStyle) {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Auto-detect style from page if not provided (try candidates in order)
    var preloadCandidates = (preloadStyle ? [preloadStyle] : []).concat(styleCandidatesFromPage());

    if (!dataLoaded) {
      showSpinner();
      loadData(function () {
        hideSpinner();
        if (!selectedA) preloadFirst(preloadCandidates, 'a');
      });
    } else {
      if (!selectedA) preloadFirst(preloadCandidates, 'a');
    }

    if (!window.btProductHandlesReady) {
      document.addEventListener('btHandlesReady', function onReady() {
        document.removeEventListener('btHandlesReady', onReady);
        if (selectedA && selectedB) renderComparison();
      });
    }
  }

  function closeGuide() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function loadData(cb) {
    var links = document.querySelectorAll('link[href*="bt-spec-guide-v9.css"]');
    var base = '/cdn/shop/t/';
    if (links.length) {
      base = links[0].getAttribute('href').replace(/bt-spec-guide[^/]*$/, '');
    }
    var specLoaded = false, mapLoaded = false;

    function checkDone() {
      if (specLoaded && mapLoaded) {
        dataLoaded = true;
        if (cb) cb();
      }
    }

    fetch(base + 'bt-spec-guide-data-v11.json')
      .then(function (r) { return r.json(); })
      .then(function (d) { DATA = d; specLoaded = true; checkDone(); })
      .catch(function () { specLoaded = true; checkDone(); });

    fetch(base + 'bt-product-style-map.json')
      .then(function (r) { return r.json(); })
      .then(function (d) { window.btStyleMap = d; mapLoaded = true; checkDone(); })
      .catch(function () { mapLoaded = true; checkDone(); });
  }

  // Normalize a brand name to handle form (lowercase, punctuation/space -> dashes).
  function brandToken(brand) {
    return (brand || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  // Does the current page handle contain this brand? (Shopify handles lead with brand.)
  function handleMatchesBrand(brand) {
    var h = window.location.pathname.toLowerCase();
    var tok = brandToken(brand);
    if (!tok) return false;
    if (h.indexOf(tok) !== -1) return true;
    var first = tok.split('-')[0];
    return first.length >= 4 && h.indexOf(first) !== -1;
  }

  function preloadFirst(candidates, panel) {
    if (!candidates || !candidates.length) return;
    for (var i = 0; i < candidates.length; i++) {
      var cand = candidates[i];
      var styleLC = cand.toLowerCase();
      var matches = [];
      for (var j = 0; j < DATA.length; j++) {
        if (DATA[j].style.toLowerCase() === styleLC) matches.push(DATA[j]);
      }
      if (!matches.length) continue;
      // A candidate is "strict" if it's a bare number AND a sibling candidate is the same
      // number with a single letter prefix (i.e. this came from the prefix-strip fallback,
      // e.g. 1533 derived from N1533). Strict candidates must match the page brand, else skip,
      // so a coincidental cross-brand number can never mismap.
      var strict = /^\d/.test(cand) && candidates.some(function (o) {
        return o !== cand && /^[A-Za-z]$/.test(o.charAt(0)) && o.slice(1) === cand;
      });
      if (strict) {
        var sp = null;
        for (var s2 = 0; s2 < matches.length; s2++) { if (handleMatchesBrand(matches[s2].brand)) { sp = matches[s2]; break; } }
        if (sp) { selectProduct(sp, panel); return; } else { continue; }
      }
      // Non-strict: if several share the number, prefer the brand in the page handle.
      var pick = matches[0];
      if (matches.length > 1) {
        for (var k = 0; k < matches.length; k++) {
          if (handleMatchesBrand(matches[k].brand)) { pick = matches[k]; break; }
        }
      }
      selectProduct(pick, panel); return;
    }
  }

  function preload(style, panel) {
    var styleLC = style.toLowerCase();
    for (var i = 0; i < DATA.length; i++) {
      if (DATA[i].style.toLowerCase() === styleLC) {
        selectProduct(DATA[i], panel);
        break;
      }
    }
  }

  function cleanTitle(title) {
    title = title.replace(/&#174;/g,'').replace(/&#153;/g,'').replace(/&#169;/g,'').replace(/&amp;/g,'&').replace(/&quot;/g,'"');
    return title
      .replace(/[®™]/g, '')
      .replace(/\s*[-–—]\s*/g, ' - ')
      .replace(/\s{2,}/g, ' ')
      .replace(/\.\s*$/, '')
      .trim();
  }

  // Tokenized search: split the query on spaces and require EVERY word to appear
  // somewhere in style + brand + title + category. Lets clients narrow a vendor
  // search ("sport-tek polo") instead of being stuck with one substring.
  var SEARCH_LIMIT = 100;

  // Title-sniff for discontinued items (titles are prefixed 'DISCONTINUED').
  // TODO: replace with a real `discontinued` field once the merge emits one.
  function isDiscontinued(p) {
    return (p.title || '').trim().toLowerCase().indexOf('discontinued') === 0;
  }

  // Parse a style into prefix/number/suffix so we can rank lower numbers and
  // base styles (shorter prefix/suffix) ahead of variants (e.g. ST650 before
  // LST650 / YST650, and ST550 before ST650).
  function styleKey(style) {
    var s = (style || '').toUpperCase();
    var m = s.match(/^([A-Z]*)(\d+)([A-Z]*)$/);
    if (m) return { num: parseInt(m[2], 10), pre: m[1].length, suf: m[3].length, raw: s };
    return { num: Infinity, pre: s.length, suf: 0, raw: s };
  }

  function search(query) {
    if (!query || query.trim().length < 2) return { items: [], total: 0 };
    var raw = query.toLowerCase().trim();
    var tokens = raw.split(/\s+/).filter(Boolean);
    var matches = [];
    for (var i = 0; i < DATA.length; i++) {
      var p = DATA[i];
      if (isDiscontinued(p)) continue;
      var styleLC = (p.style || '').toLowerCase();
      var hay = styleLC + ' ' + (p.brand || '').toLowerCase() + ' ' +
                (p.title || '').toLowerCase() + ' ' + (p.category || '').toLowerCase();
      var allMatch = true;
      for (var t = 0; t < tokens.length; t++) {
        if (hay.indexOf(tokens[t]) === -1) { allMatch = false; break; }
      }
      if (!allMatch) continue;
      var tier = (styleLC === raw) ? 0 : (styleLC.indexOf(raw) === 0 ? 1 : 2);
      matches.push({ p: p, tier: tier, k: styleKey(p.style) });
    }
    matches.sort(function (a, b) {
      if (a.tier !== b.tier) return a.tier - b.tier;        // exact, then prefix, then rest
      if (a.k.num !== b.k.num) return a.k.num - b.k.num;    // lower style numbers first
      if (a.k.pre !== b.k.pre) return a.k.pre - b.k.pre;    // base (shorter prefix) first
      if (a.k.suf !== b.k.suf) return a.k.suf - b.k.suf;    // base (shorter suffix) first
      return a.k.raw < b.k.raw ? -1 : (a.k.raw > b.k.raw ? 1 : 0);
    });
    var ranked = matches.map(function (m) { return m.p; });
    return { items: ranked.slice(0, SEARCH_LIMIT), total: ranked.length };
  }

  function renderDropdown(result, el) {
    var items = result.items || [];
    var total = result.total || 0;
    if (!items.length) {
      el.innerHTML = '<div class="bt-sg-no-results">No results — try a style number, brand, or product name</div>';
    } else {
      var rows = items.map(function (p) {
        return '<div class="bt-sg-dropdown-item" data-style="' + esc(p.style) + '">' +
          '<div class="bt-sg-item-brand">' + esc(p.brand) + '</div>' +
          '<div class="bt-sg-item-title">' + esc(cleanTitle(p.title)) + '</div>' +
          '<div class="bt-sg-item-meta">' + esc(p.style) + ' \u00b7 ' + esc(p.available_sizes || '') + '</div>' +
        '</div>';
      }).join('');
      var count = (total > items.length)
        ? 'Showing ' + items.length + ' of ' + total + ' \u2014 keep typing to narrow'
        : total + (total === 1 ? ' result' : ' results');
      el.innerHTML = rows + '<div class="bt-sg-drop-count">' + count + '</div>';
    }
    el.classList.add('is-open');
    fitDropdownHeight(el);
  }

  function fitDropdownHeight(el) {
    var dialog = el.closest('.bt-sg-dialog') || document.getElementById('bt-sg-inner');
    if (!dialog) return;
    var elTop = el.getBoundingClientRect().top;
    var dialogBottom = dialog.getBoundingClientRect().bottom;
    var room = dialogBottom - elTop - 16;
    var h = Math.max(240, Math.min(room, 480));
    el.style.maxHeight = h + 'px';
    el.style.overflowY = 'auto';
  }

  function setupPanel(panel) {
    var input    = document.getElementById('bt-sg-search-' + panel);
    var dropdown = document.getElementById('bt-sg-dropdown-' + panel);
    var clearBtn = document.getElementById('bt-sg-clear-' + panel);
    if (!input) return;

    input.addEventListener('input', function () {
      var q = this.value.trim();
      clearBtn.style.display = q ? 'block' : 'none';
      if (q.length >= 2) renderDropdown(search(q), dropdown);
      else dropdown.classList.remove('is-open');
    });

    input.addEventListener('focus', function () {
      if (this.value.trim().length >= 2) dropdown.classList.add('is-open');
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.style.display = 'none';
      dropdown.classList.remove('is-open');
    });

    dropdown.addEventListener('click', function (e) {
      var item = e.target.closest('.bt-sg-dropdown-item');
      if (!item) return;
      var style = item.getAttribute('data-style');
      for (var i = 0; i < DATA.length; i++) {
        if (DATA[i].style === style) {
          selectProduct(DATA[i], panel);
          dropdown.classList.remove('is-open');
          input.value = DATA[i].brand + ' ' + DATA[i].style;
          break;
        }
      }
    });

    document.addEventListener('click', function (e) {
      if (!input.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.classList.remove('is-open');
      }
    });
  }

  function selectProduct(product, panel) {
    if (panel === 'a') selectedA = product;
    else selectedB = product;
    document.getElementById('bt-sg-panel-' + panel).classList.add('has-product');
    renderCard(product, panel);
    renderComparison();
  }

  function clearPanel(panel) {
    if (panel === 'a') selectedA = null;
    else selectedB = null;
    document.getElementById('bt-sg-panel-' + panel).classList.remove('has-product');
    document.getElementById('bt-sg-card-' + panel).classList.remove('is-visible');
    document.getElementById('bt-sg-search-' + panel).value = '';
    document.getElementById('bt-sg-clear-' + panel).style.display = 'none';
    renderComparison();
  }

  function renderMeasurements(product, panel, size) {
    var m = product.measurements;
    var container = document.getElementById('bt-sg-card-' + panel + '-meas');
    if (!container) return;
    if (!m || Object.keys(m).length === 0) {
      container.innerHTML = '<div class="bt-sg-meas-section bt-sg-meas-section--none"><p class="bt-sg-no-meas">No measurements available</p></div>';
      return;
    }
    var sizes = Object.keys(m);
    if (!size || !m[size]) size = sizes[0];
    var dims = m[size];
    var btnHtml = sizes.map(function(s) {
      return '<button class="bt-sg-sz-btn' + (s === size ? ' bt-sg-sz-active' : '') + '" data-sz="' + esc(s) + '">' + esc(s) + '</button>';
    }).join('');
    var rowHtml = Object.keys(dims).map(function(dim) {
      return '<tr><td class="bt-sg-meas-dim">' + esc(dim) + '</td><td class="bt-sg-meas-val">' + esc(dims[dim]) + '"</td></tr>';
    }).join('');
    container.innerHTML =
      '<div class="bt-sg-meas-section">' +
        '<div class="bt-sg-meas-label">Measurements (inches)</div>' +
        '<div class="bt-sg-sz-row" id="bt-sg-sz-row-' + panel + '">' + btnHtml + '</div>' +
        '<table class="bt-sg-meas-table"><thead><tr>' +
          '<th>Dimension</th><th>Value</th>' +
        '</tr></thead><tbody>' + rowHtml + '</tbody></table>' +
      '</div>';
    document.getElementById('bt-sg-sz-row-' + panel).addEventListener('click', function(e) {
      var btn = e.target.closest('.bt-sg-sz-btn');
      if (!btn) return;
      renderMeasurements(product, panel, btn.getAttribute('data-sz'));
    });
  }

  function renderCard(product, panel) {
    document.getElementById('bt-sg-card-' + panel + '-name').textContent = cleanTitle(product.title);
    document.getElementById('bt-sg-card-' + panel + '-meta').textContent = product.brand + ' \u00b7 ' + product.style;

    // Full labeled spec table, shown for the autopopulated product immediately.
    // Empty fields are omitted so sparse records (e.g. missing blend) stay clean.
    var sizesVal = product.available_sizes || (product.sizes || []).join(', ');
    var specDefs = [
      { l: 'Weight',   v: product.weight },
      { l: 'Fabric',   v: product.blend },
      { l: 'Category', v: product.category },
      { l: 'Sizes',    v: sizesVal },
      { l: 'Style #',  v: product.style }
    ];
    var specRows = specDefs.filter(function (s) { return s.v; }).map(function (s) {
      return '<tr><td class="bt-sg-card-spec-l">' + s.l + '</td>' +
             '<td class="bt-sg-card-spec-v">' + esc(s.v) + '</td></tr>';
    }).join('');
    var specsEl = document.getElementById('bt-sg-card-' + panel + '-specs');
    if (specsEl) {
      specsEl.innerHTML =
        '<div class="bt-sg-card-spec-label">Specifications</div>' +
        '<table class="bt-sg-card-spec-table"><tbody>' + specRows + '</tbody></table>';
    }

    // Pills carry weight/blend/category, which now also appear in the table above;
    // keep the pills empty to avoid duplication (table is the source of truth).
    var pillsEl = document.getElementById('bt-sg-card-' + panel + '-pills');
    if (pillsEl) pillsEl.innerHTML = '';

    renderMeasurements(product, panel, null);
    document.getElementById('bt-sg-card-' + panel).classList.add('is-visible');
  }

  function productUrl(style) {
    var styleLC = style.toLowerCase();

    // Check current page first (exact style segment only, so TT51 != TT51Y)
    var currentHandle = window.location.pathname.replace('/products/', '').split('?')[0];
    if (currentHandle.toLowerCase().split('-').indexOf(styleLC) !== -1) {
      return window.location.pathname;
    }

    // Check static style map
    var map = window.btStyleMap || {};
    if (map[style.toUpperCase()]) return map[style.toUpperCase()];

    // Handle search, tiered so we never fall back to a greedy substring that
    // would let TT51 match TT51Y/TT51W or 18500 match 18500B.
    var handles = window.btProductHandles || [];
    // 1) handle is exactly the style
    for (var i = 0; i < handles.length; i++) {
      if (handles[i].handle.toLowerCase() === styleLC) return handles[i].url;
    }
    // 3a) clean base: handle ENDS with the style (style as final segment).
    //     Tried before the looser anywhere-segment match so a base page wins over
    //     split 'extended-colors' pages (where the style sits mid-handle).
    for (var i = 0; i < handles.length; i++) {
      if (handles[i].handle.toLowerCase().endsWith('-' + styleLC)) return handles[i].url;
    }
    // 3b) fallback: style appears as a WHOLE segment anywhere (catches split-only
    //     products with no clean base, e.g. ...-pc54-extended-colors-2).
    for (var i = 0; i < handles.length; i++) {
      if (handles[i].handle.toLowerCase().split('-').indexOf(styleLC) !== -1) return handles[i].url;
    }
    return null;
  }

  function renderComparison() {
    var area = document.getElementById('bt-sg-compare');
    if (!selectedA || !selectedB) { area.classList.remove('is-visible'); return; }
    area.classList.add('is-visible');

    // Compact comparison cards: the full specs now live in each panel's card
    // above, so down here we keep only what isn't a duplicate — the Shop buttons.
    document.getElementById('bt-sg-spec-grid').innerHTML = [selectedA, selectedB].map(function (p) {
      var shopUrl = productUrl(p.style);
      // Three states: while the product-handles list is still loading we can't yet
      // know if we carry this style, so show a pending label rather than a false
      // "Not in our catalog". The btHandlesReady listener re-renders when ready.
      var shopBtn = !window.btProductHandlesReady
        ? '<span class="bt-sg-shop-btn not-found">Loading…</span>'
        : (shopUrl
          ? '<a href="' + shopUrl + '" class="bt-sg-shop-btn" target="_blank">Shop ' + esc(p.style) + '</a>'
          : '<span class="bt-sg-shop-btn not-found inert" aria-hidden="true"></span>');
      return '<div class="bt-sg-spec-card bt-sg-spec-card--compact">' +
        '<div class="bt-sg-spec-card-brand">' + esc(p.brand) + '</div>' +
        '<div class="bt-sg-spec-card-name">' + esc(cleanTitle(p.title)) + '</div>' +
        shopBtn +
      '</div>';
    }).join('');

    var sizesA = selectedA.sizes || [];
    var sizesB = selectedB.sizes || [];
    var shared = sizesA.filter(function (s) { return sizesB.indexOf(s) !== -1; });

    document.getElementById('bt-sg-size-tbody').innerHTML = [
      { product: selectedA, sizes: sizesA },
      { product: selectedB, sizes: sizesB }
    ].map(function (row) {
      return '<tr>' +
        '<td>' + esc(row.product.brand) + ' ' + esc(row.product.style) +
          '<br><span style="font-size:11px;color:#bbb;font-weight:400">' + esc(cleanTitle(row.product.title)) + '</span>' +
        '</td>' +
        '<td>' + row.sizes.map(function (s) {
          return '<span class="bt-sg-size-chip' + (shared.indexOf(s) !== -1 ? ' shared' : '') + '">' + esc(s) + '</span>';
        }).join('') + '</td>' +
      '</tr>';
    }).join('');

    document.getElementById('bt-sg-size-note').textContent = shared.length
      ? 'Green = sizes available in both blanks (' + shared.join(', ') + ')'
      : 'No overlapping sizes between these two blanks.';
  }

  function showSpinner() { if (spinner) spinner.classList.add('is-visible'); }
  function hideSpinner() { if (spinner) spinner.classList.remove('is-visible'); }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  window.btSpecGuide = { open: openGuide };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
